<style lang="scss" scoped>
.footer {
  height: 40px;
  width: 100%;
  background-image: url(../assets/footer.png);
  background-repeat: repeat-x;
  position: fixed;
  bottom: 0;
  &::before {
    content: '';
    width: 100%;
    height: 100px;
    position: absolute;
    left: 0;
    bottom: 40px;
    background: rgba($color: #000, $alpha: 0.3);
    background: -webkit-linear-gradient(to bottom, transparent, rgba($color: #000, $alpha: 0.3));
    background: linear-gradient(to bottom, transparent, rgba($color: #000, $alpha: 0.3));
  }
}
</style>
<template>
  <div class="footer"></div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    ready() {}
  }
};
</script>